import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getSafePostLoginRedirect } from "../../utils/postLoginRedirect";
import { useDispatch, useSelector } from "react-redux";
import { loginRequest, reset } from "../../redux/auth/login/actions";
import { showToast } from "../../Components/Common/Toast";
import { AuthContext } from "../../Auth/AuthContext";
import { getTotalPointsRequest } from "../../redux/get_total_points/actions";
import Cookies from "universal-cookie"; // Import Cookies as default
import { ToastContainer } from "react-toastify";
import logoWhite from "../../assets/images/logo/logo.png";
const LoginForm = ({ onOpenCentralLogin }) => {
  const { user, setUser } = useContext(AuthContext);
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const [togglePassword, setTogglePassword] = useState(false);
  const { type } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [errors, setErrors] = useState({});
  const [rememberPassword, setRememberPassword] = useState(true);
  const activeLoginType =
    type?.toUpperCase() === "RECRUITER" ? "RECRUITER" : "JOBSEEKER";
  const loginTabs = [
    { key: "JOBSEEKER", label: "Jobseeker" },
    { key: "RECRUITER", label: "Recruiter" },
  ];

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    type: activeLoginType,
  });

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      type: activeLoginType,
    }));
    setErrors({});
  }, [activeLoginType]);



  useEffect(() => {
    if (user && user.isLoggedin === true) {
      const safe = getSafePostLoginRedirect(
        searchParams.get("redirect"),
        activeLoginType
      );
      setTimeout(() => {
        navigate(
          safe || `${process.env.PUBLIC_URL}/${type.toLowerCase()}/dashboard`
        );
      }, 1000);
    }
  }, [user, type, navigate, searchParams, activeLoginType]);

  const handleCheckboxChange = (event) => {
    setRememberPassword(event.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const formattedData = {
        email: formData.email,
        password: formData.password,
        type: formData.type,
      };
      dispatch(loginRequest(formattedData));
    }
  };

  const validate = () => {
    let errors = {};
    let isValid = true;

    if (!formData.email) {
      errors.email = "Email is required";
      isValid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(formData.email)) {
        errors.email = "Please enter a valid email";
        isValid = false;
      }
    }

    if (!formData.password) {
      errors.password = "Password is required";
      isValid = false;
    } else if (formData.password.length < 8) {
      errors.password = "Password must be at least 8 characters long";
      isValid = false;
    } else if (!/[a-z]/.test(formData.password)) {
      errors.password = "Password must contain at least one lowercase letter";
      isValid = false;
    } else if (!/[A-Z]/.test(formData.password)) {
      errors.password = "Password must contain at least one uppercase letter";
      isValid = false;
    } else if (!/\d/.test(formData.password)) {
      errors.password = "Password must contain at least one digit";
      isValid = false;
    } else if (!/[^a-zA-Z\d]/.test(formData.password)) {
      errors.password = "Password must contain at least one special character";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    setErrors({ ...errors, [name]: error });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const loginReducerData = useSelector((state) => state.loginReducer);
  const loginData = loginReducerData.data;

  useEffect(() => {

    if (loginReducerData.status && loginReducerData.message) {
      console.log("loginData", loginReducerData.message);
      showToast("success", loginReducerData.message);
      dispatch(reset());
      // console.log("loginData", loginData);
      const user_data = {
        name: loginData.name,
        email: loginData.email,
        type: loginData.type,
        recruiter_id: loginData.id,
        phone: loginData.phone ?? "",
      };
      localStorage.setItem("_token", loginData.token);
      localStorage.setItem("user_data", JSON.stringify(user_data));


      const safe = getSafePostLoginRedirect(
        searchParams.get("redirect"),
        loginData.type || activeLoginType
      );
      setTimeout(() => {
        navigate(
          safe || `${process.env.PUBLIC_URL}/${type}/dashboard`
        );
      }, 1000);

      dispatch(getTotalPointsRequest());
    } else if (!loginReducerData.status && loginReducerData.message) {
      showToast("error", loginReducerData.message);
      dispatch(reset());
    }
  }, [loginReducerData, dispatch, navigate, type, loginData, searchParams, activeLoginType]);

  const ref_code = cookies.get("ref_code");
  const ref_type = cookies.get("ref_type");
  const queryParams = [];
  if (ref_code) queryParams.push(`ref_code=${encodeURIComponent(ref_code)}`);
  if (ref_type) queryParams.push(`ref_type=${encodeURIComponent(ref_type)}`);

  const fullUrl = `https://zoblik.com/sso/login_page.php?site=xyntara.in/job` +
    (queryParams.length ? `&${queryParams.join("&")}` : "");
  console.log("fullUrl44", fullUrl);

  const handleTypeSwitch = (nextType) => {
    if (nextType !== activeLoginType) {
      const red = searchParams.get("redirect");
      const q = red
        ? `?redirect=${encodeURIComponent(red)}`
        : "";
      navigate(
        `${process.env.PUBLIC_URL}/${nextType.toLowerCase()}/auth/login${q}`
      );
    }
  };


  return (
    <Fragment>
      <div className="login-card">
        <div>
          <div className="login-main">
            <Link className="logo" to={process.env.PUBLIC_URL}>
              <img
                id="img_logo"
                className="img-fluid for-light"
                src={logoWhite}
                alt="loginpage"
                style={{ width: "60%" }}
              />
            </Link>
            <Nav
              tabs
              className="justify-content-center mb-4"
              role="tablist"
              aria-label="Login type switcher"
            >
              {loginTabs.map((tab) => (
                <NavItem key={tab.key}>
                  <NavLink
                    tag="button"
                    type="button"
                    className={activeLoginType === tab.key ? "active" : ""}
                    onClick={() => handleTypeSwitch(tab.key)}
                    style={{ cursor: "pointer" }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            {/* for recruiter */}
            {activeLoginType === 'RECRUITER' && (
              <Form className="theme-form login-form" onSubmit={handleSubmit}>
                <h4>Sign in as {activeLoginType}</h4>
                <p>Enter your email & password to login</p>
                <FormGroup>
                  <Label className="col-form-label m-0">
                    Email Address <span className="text-danger">*</span>
                  </Label>
                  <Input
                    className="form-control"
                    type="text"
                    name="email"
                    placeholder="abc@gmail.com"
                    onChange={handleChange}
                    maxLength={50}
                  />
                  {errors.email && (
                    <small className="text-danger">{errors.email}</small>
                  )}
                </FormGroup>
                <FormGroup className="position-relative">
                  <Label className="col-form-label m-0">
                    Password <span className="text-danger">*</span>
                  </Label>
                  <div className="position-relative">
                    <Input
                      className="form-control"
                      type={togglePassword ? "text" : "password"}
                      name="password"
                      placeholder="********"
                      onChange={handleChange}
                    />
                    <div
                      className="show-hide"
                      onClick={() => setTogglePassword(!togglePassword)}
                    >
                      <span className={togglePassword ? "" : "show"}></span>
                    </div>
                  </div>
                  {errors.password && (
                    <small className="text-danger">{errors.password}</small>
                  )}
                </FormGroup>
                <FormGroup className="position-relative">
                  <div className="checkbox">
                    <Link
                      to={`${process.env.PUBLIC_URL
                        }/${type.toLowerCase()}/auth/forgot_password`}
                    >
                      Forgot password?
                    </Link>
                  </div>
                </FormGroup>
                <FormGroup>
                  <Button
                    className="d-block w-100 mt-2"
                    color="primary"
                    type="submit"
                    disabled={loginReducerData.isLoading}
                  >
                    Sign in
                  </Button>
                </FormGroup>
                <p className="text-start mb-0">
                  Don't have an account?
                  <Link
                    className="ms-2"
                    to={`${process.env.PUBLIC_URL
                      }/${activeLoginType.toLowerCase()}/auth/register`}
                  >
                    Create Account
                  </Link>
                </p>
              </Form>
            )}

            {/* for jobseeker */}
            {activeLoginType === 'JOBSEEKER' && (
              <div>
                <h4>Sign in as {activeLoginType}</h4>
                <button
                  type="button"
                  id="googleLoginBtn"
                  className="btn d-block w-100 mt-2 btn-primary mt-3 mb-2"
                  data-login-url={fullUrl}
                  onClick={(e) => {
                    e.preventDefault();
                    onOpenCentralLogin?.();
                  }}
                >
                  Sign In with Google
                </button>
                {/* <p className="text-start mb-0">
                  Don't have an account?
                  <Link
                    className="ms-2"
                    to={`${process.env.PUBLIC_URL
                      }/${activeLoginType.toLowerCase()}/auth/register`}
                  >
                    Create Account
                  </Link>
                </p> */}
              </div>
            )}

            <div className="mt-3">
              <Link to={`${process.env.PUBLIC_URL}/public/support`} className="btn btn-outline-primary w-100">
                Help &amp; Support
              </Link>
            </div>
          </div>
        </div>
      </div>

    </Fragment>

  );
};

export default LoginForm;
